import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { updateServiceAgreementAsync } from "../../../../slices/service/agreements";
import { FormikSaveBar } from "../../../utils/FormikSaveBar";
import { ResourceLoading } from "../../../utils/ResourceLoading";
import { runUpdateAgreementOrderlinesOperation } from "./runUpdateAgreementOrderlinesOperation";
import { AgreementFormErrorSummary } from "./AgreementFormErrorSummary";
import { AgreementLinesEditor, toEditableLines, toOrderlinesPayload, validateLines } from "./AgreementLinesEditor";

export const ServiceAgreementOrderlines = (props) => {
  const { t } = useTranslation();
  const { item, onRefresh, isLoading } = props;
  const dispatch = useDispatch();
  const currentCompany = useSelector((state) => state.session.currentCompany);

  if (isLoading) {
    return <ResourceLoading />;
  }
  return (
    <Formik
      enableReinitialize
      initialValues={{
        id: item?.id,
        interval_mode: item?.interval_mode || "agreement",
        lines: toEditableLines(item?.orderlines),
      }}
      validate={(values) => {
        const lineErrors = validateLines(values.lines, t);
        return Object.keys(lineErrors).length ? { lines: lineErrors } : {};
      }}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={async (values, helpers) => {
        try {
          helpers.setSubmitting(true);
          const result = await runUpdateAgreementOrderlinesOperation({
            dispatch,
            updateAsync: updateServiceAgreementAsync,
            values: { id: values.id, interval_mode: values.interval_mode, orderlines: toOrderlinesPayload(values.lines) },
            companyId: currentCompany?.id,
            onRefresh,
            t,
          });
          helpers.setStatus({ success: result.ok });
        } catch (err) {
          console.error(err);
          helpers.setStatus({ success: false });
          helpers.setErrors({
            submit: err?.message || t("operation_feedback.generic_error"),
          });
        } finally {
          helpers.setSubmitting(false);
        }
      }}
    >
      {(formik) => (
        <Form>
          <div className="mb-4">
            <AgreementFormErrorSummary formik={formik} />
          </div>
          <AgreementLinesEditor
            lines={formik.values.lines}
            onChange={(lines) => formik.setFieldValue("lines", lines, false)}
            intervalMode={formik.values.interval_mode}
            onIntervalModeChange={(mode) => formik.setFieldValue("interval_mode", mode, false)}
            errors={formik.errors.lines}
            disabled={formik.isSubmitting}
          />
          <FormikSaveBar {...formik} disabled={formik.isSubmitting} />
        </Form>
      )}
    </Formik>
  );
};
